import { AGREEMENT_STATUS_LABELS } from '../../config/contracts';
import { tenantRoleLabel } from '../../config/tenantRoles';

// Filters of the Activity tab, matching the API's categories.
export const ACTIVITY_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'members', label: 'Members' },
  { id: 'data', label: 'Data' },
  { id: 'services', label: 'Services' },
  { id: 'organisation', label: 'Organisation' },
  { id: 'privacy', label: 'Privacy' },
];

export const actorOf = (event) => event.actor_name || event.actor_email || 'The Hub';

const targetOf = (event) => event.target_name || event.target_email || 'a member';

const role = (event) => tenantRoleLabel(event.metadata?.role);

/** One plain sentence (without the actor) for an audit event. */
export const describeActivity = (event) => {
  const meta = event.metadata || {};
  switch (event.action) {
    case 'membership.invite':
      return `invited ${meta.email || 'someone'} as ${role(event)}`;
    case 'membership.invite_resend':
      return `resent the invitation to ${meta.email || 'someone'}`;
    case 'membership.invite_revoke':
      return `revoked the invitation to ${meta.email || 'someone'}`;
    case 'membership.invite_accept':
      return `accepted an invitation and joined as ${role(event)}`;
    case 'membership.join':
      return `joined through the organisation's sign-on group as ${role(event)}`;
    case 'membership.add':
      return `added ${targetOf(event)} as ${role(event)}`;
    case 'membership.update':
      return `changed the role of ${targetOf(event)} to ${role(event)}`;
    case 'membership.remove':
      return `removed ${targetOf(event)}`;
    case 'tenant.create':
      return 'created the organisation';
    case 'tenant.branding_update':
      return "updated the organisation's branding";
    case 'tenant.keycloak_reconcile':
      return "set up the organisation's sign-on group";
    case 'building.create':
      return 'added a building';
    case 'offer.accept':
      return 'accepted a data offer';
    case 'agreement.create':
      return 'proposed a data agreement';
    case 'agreement.status_change': {
      const status = AGREEMENT_STATUS_LABELS[Number(meta.status)];
      return status ? `marked a data agreement ${status.toLowerCase()}` : 'changed the status of a data agreement';
    }
    case 'ingestion.cdm_record':
      return 'ingested a building data record';
    case 'eubso.aggregate':
      return 'ran an EU BSO aggregation';
    case 'wp3.invoke':
      return `used ${meta.serviceName || 'an AI service'}`;
    case 'privacy.data_export':
      return 'downloaded their personal data';
    default:
      return `performed ${event.action}`;
  }
};
